import { createContext, useContext } from 'react';

type Context = {
  debouncedSearch: string;
  search: string;
  setSearch: (val: string) => void;
  setStatus: (vals: string[]) => void;
  /* comma separated list of statuses */
  status: string[];
};

export const FiltersContext = createContext<Context | undefined>(undefined);

export const useFiltersContext = () => {
  const context = useContext(FiltersContext);
  if (context === undefined) {
    throw new Error('useFiltersContext must be used within a FiltersContextProvider');
  }
  return context;
};
